import { render, staticRenderFns } from "./GlobalSpecsFormMaterialRow.vue?vue&type=template&id=8799746a&"
import script from "./GlobalSpecsFormMaterialRow.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsFormMaterialRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports